/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PigExcelResultDto } from '../../models/pig-excel-result-dto';

export interface ExcelControllerPigExcelUpload$Params {

/**
 * 상품 ID
 */
  productId: string;
  strategy?: 'fail' | 'overwrite' | 'skip';
      body: {
'file'?: Blob;
}
}

export function excelControllerPigExcelUpload(http: HttpClient, rootUrl: string, params: ExcelControllerPigExcelUpload$Params, context?: HttpContext): Observable<StrictHttpResponse<PigExcelResultDto>> {
  const rb = new RequestBuilder(rootUrl, excelControllerPigExcelUpload.PATH, 'post');
  if (params) {
    rb.query('productId', params.productId, {});
    rb.query('strategy', params.strategy, {});
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PigExcelResultDto>;
    })
  );
}

excelControllerPigExcelUpload.PATH = '/api/excel/pig';
